import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    text: String,
    successText: { type: String, default: "Copied" },
  }

  async copy() {
    if (!this.hasTextValue || this.textValue.length === 0) return

    const original = this.element.textContent
    await navigator.clipboard.writeText(this.textValue)
    this.element.textContent = this.successTextValue

    setTimeout(() => {
      this.element.textContent = original
    }, 1200)
  }
}
